import React from "react";
import ActionLike from "./ActionLike";

const ChatMessage = ({
    message,
    idx,
    themes,
    handleLike = null,
    messages = [],
}) => {
    // Hiển thị tin nhắn hệ thống một cách khác biệt
    if (message.isSystemMessage) {
        return <div className="chatbot-system-message">{message.msg}</div>;
    }

    return (
        <div
            className={`mt-3 ${message.fromUser
                    ? "place-self-end text-right"
                    : "place-self-start text-left"
                }`}
        >
            <div
                className="mt-3 p-3 rounded-2xl"
                style={{
                    backgroundColor: message.fromUser ? themes.primaryColor : "white",
                    color: message.fromUser
                        ? themes.primaryFontColor
                        : themes.secondryFontColor,
                    borderTopLeftRadius: !message.fromUser && 0,
                    borderTopRightRadius: message.fromUser && 0,
                }}
            >
                <div
                    dangerouslySetInnerHTML={{
                        __html: message.msg.replace(/\n/g, "<br/>"),
                    }}
                    className="break-words text-md"
                />
                {/* <ActionLike
          fromUser={message.fromUser}
          length={messages.length}
          idx={idx}
          like={message.like || false}
          dislike={message.dislike || false}
          handleLike={handleLike}
        /> */}
            </div>
        </div>
    );
};

export default ChatMessage;
